// Refer to the Social network API for reference :
// https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-fetch_http_request
// FAQ list 
// https://clpapi.tinkeredu.co.kr/board/FAQ/article?id,desc
// FAQ detail 
// https://clpapi.tinkeredu.co.kr/board/FAQ/article/23
import httpService from '@/api/httpService'
const helpdeskApi = {
    // 나의 학습목록(get helpdesk list)
    // https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-fetch_http_request
    fetchList(params) {
        return httpService.get(`/board/FAQ/article?sort=id,asc`, params)
    },

    // 나의 학습 달성률(get learning progress rate)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learner.html#resources-degree-learner-progressrate-detail
    // learnProgressRate(params) {
    //     return httpService.get(`/learn/learner/online/${params.id}/progressRate/detail`)
    // },

    // 나의 학습 상세 기본정보(get learning basic information)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_learner.html#resources-degree-learner-detail
    getFaqDetails(id) {
        return httpService.get(`/board/FAQ/article/`+id)
        //return httpService.get(`/board/FAQ/article/${params.learnId}`)
    },


}

// export const 
export default helpdeskApi